import { Commands } from "../../../../vendor_core/core/src/commands/CommandEnum";
import CommandManager from "../../../../vendor_core/core/src/commands/CommandManager";
import { UpdateBalanceCommand } from "../../../../vendor_core/core/src/commands/GameCommands";
import PointerEvents from "../../../../vendor_core/core/src/const/PointerEvents";
import SoundVars from "../../../../vendor_core/core/src/const/SoundVars";
import BetModel from "../../../../vendor_core/core/src/model/BetModel";
import BuyFeatureModel from "../../../../vendor_core/core/src/model/BuyFeatureModel";
import { UIButtons } from "../../../../vendor_core/core/src/ui/UIButtons";
import { UIComponents } from "../../../../vendor_core/core/src/ui/UIComponents";
import UIController from "../../../../vendor_core/core/src/ui/UIController";
import { UIModes } from "../../../../vendor_core/core/src/ui/UIStates";
import AbstractPopup from "../../../../vendor_core/core/src/ui/popups/AbstractPopup";
import KeyboardManager from "../../../../vendor_core/core/src/utils/KeyboardManager";
import { DefaultLayers } from "../../../../vendor_core/core/src/utils/Layers";
import Locale from "../../../../vendor_core/core/src/utils/Locale";
import SoundController from "../../../../vendor_core/core/src/utils/SoundController";
import ViewManager from "../../../../vendor_core/core/src/utils/ViewManager";
import { MoneyField } from "../../../../vendor_core/core/src/views/MoneyField";
import SceneView from "../../../../vendor_core/core/src/views/SceneView";
import Button from "../../../../vendor_core/core/src/views/components/Button";
import SwitchButton from "../../../../vendor_core/core/src/views/components/SwitchButton";
import TextField from "../../../../vendor_core/core/src/views/components/TextField";
import { VendorCommandsEnum } from "../../../../vendor_core/src/commands/VendorCommandsEnum";
import Configs from "../../../../vendor_core/src/vendorConfigs/Configs";


export default class BuyFeatureSpinPopup extends AbstractPopup {

    public btnActivate: Button;
    public betField: MoneyField;
    public betBarBetField: MoneyField;
    public totalPriceField: MoneyField;
    public animScene: SceneView;
    public plusBtn: Button;
    public minusBtn: Button;

    constructor() {
        super();
        this.layer = ViewManager.getLayer(DefaultLayers.Popups);
    }

    public show(callback?: Function) {
        BuyFeatureModel.mode = 2;
        KeyboardManager.disable();
        this.hidden = false;
        this.scene = this.layer.setScene('futurebuySpin');
        this.scene.interactive = true;
        this.betField = this.scene.sceneMoneyFields.get('amount') as MoneyField;
        this.plusBtn = this.scene.buttons.get("plus") as Button;
        this.minusBtn = this.scene.buttons.get("minus") as Button;
        this.btnActivate = this.scene.buttons.get("bonus_activate") as Button;
        this.totalPriceField = this.scene.sceneMoneyFields.get('total_amount') as MoneyField;
        this.betBarBetField = ViewManager.getLayer(DefaultLayers.BetBar)
            .getCurrentScene().sceneMoneyFields.get("betBuySpin") as MoneyField;


        this.setBetOptions();
        this.setBet();
        this.betSync();
        this.disableBetOptions();
        this.setTotalPrice();
        this.setInteractionOnPlus();
        this.setInteractionOnMinus();
        this.setInteractionOnClose();
        this.setInteractionOnActivate();

        ViewManager.getLayer(DefaultLayers.SplashOverlay).setScene("open");
    }

    protected setInteractionOnClose() {
        this.scene.buttons.get("cancel").once(PointerEvents.DOWN, () => {
            SoundController.playSound(SoundVars.BUTTON_CLICK)
            KeyboardManager.enable();
            CommandManager.execute(VendorCommandsEnum.FEATURE_BUTTON_OPTIONS);
            ViewManager.getLayer(DefaultLayers.SplashOverlay).completeClear();
            // the game stake cannot be affected if the buy offer is cancelled
            ViewManager.getLayer(DefaultLayers.BetBar)
                .setScene().sceneMoneyFields.get(UIComponents.TotalBetAlternative)
                .value = BetModel.totalBet;
            this.hide();
            BuyFeatureModel.mode = 0;
        });
    }

    protected setBetOptions() {
        /*
        slice all valid bets to bets witch we displayed on the Bet Settings example case 12
        */
        let bfConfig = Configs.buyFeature;
        let betConfig = Configs.bet;

        if (bfConfig.betOptions.length > 0) {
            BuyFeatureModel.validBets = bfConfig.getBetOptions();
        } else if (betConfig.betOptions.length > 0) {
            BuyFeatureModel.validBets = betConfig.getBetOptions();
        } else {
            BuyFeatureModel.validBets = [...BetModel.creditValues];
        }

        BuyFeatureModel.currentBetIndex = BuyFeatureModel.validBets.indexOf(BetModel.totalBet);
    }

    protected setBet() {
        const config = Configs.buyFeature;
        let bet = BuyFeatureModel.validBets[BuyFeatureModel.currentBetIndex];

        if (config.maxFeaturePurchasePrice &&
            bet * config.betMultiplier[2] > config.maxFeaturePurchasePrice
        ) {
            for(let i = BuyFeatureModel.validBets.length -1; i >= 0; i--) {
                if (BuyFeatureModel.validBets[i] * config.betMultiplier[2] <= config.maxFeaturePurchasePrice) {
                    bet = BuyFeatureModel.validBets[i];
                    BuyFeatureModel.currentBetIndex = i;
                    break;
                }
            }
        }

        if (bet) {
            this.betField.value = bet;
        }
    }

    protected betSync() {
        ViewManager.getLayer(DefaultLayers.BetBar)
            .setScene().sceneMoneyFields.get(UIComponents.TotalBetAlternative)
            .value = BuyFeatureModel.getBet();
    }

    protected disableBetOptions(): void {
        const config = Configs.buyFeature;

        this.plusBtn.setEnabled(true);
        this.minusBtn.setEnabled(true);

        if (
            BuyFeatureModel.currentBetIndex >= (BuyFeatureModel.validBets.length - 1)
            || BuyFeatureModel.getTotalBet(BuyFeatureModel.currentBetIndex) >= config.maxFeaturePurchasePrice
            ) {
            this.plusBtn.setEnabled(false);
        }
        if (BuyFeatureModel.currentBetIndex === 0) {
            this.minusBtn.setEnabled(false);
        }
    }

    protected setTotalPrice() {
        let config = Configs.buyFeature;
        let price = this.betField.value * config.betMultiplier[2];
        this.totalPriceField.value = price;
        this.betBarBetField.value = price;
        this.checkBalanceEnoughForBuy(price, this.btnActivate);
    }

    protected checkBalanceEnoughForBuy(price: number, buyBtn: Button) {
        if (BetModel.balance - price >= 0 && price <= Configs.buyFeature.maxFeaturePurchasePrice) {
            buyBtn.setEnabled(true);
        } else {
            buyBtn.setEnabled(false);
        }
    }

    protected setInteractionOnPlus() {
        this.plusBtn.on(PointerEvents.DOWN, () => {
            SoundController.playSound(SoundVars.BUTTON_CLICK)
            this.incrementBet();
            this.disableBetOptions();
        })
    }

    protected incrementBet() {
        if (BuyFeatureModel.currentBetIndex < (BuyFeatureModel.validBets.length - 1)) {
            BuyFeatureModel.currentBetIndex += 1;
            this.setBet();
            this.setTotalPrice();
            this.betSync();
        }
    }

    protected setInteractionOnMinus() {
        this.minusBtn.on(PointerEvents.DOWN, () => {
            SoundController.playSound(SoundVars.BUTTON_CLICK)
            this.decrementBet();
            this.disableBetOptions();
        })
    }

    protected decrementBet() {
        if (BuyFeatureModel.currentBetIndex > 0) {
            BuyFeatureModel.currentBetIndex -= 1;
            this.setBet();
            this.setTotalPrice();
            this.betSync();
        }
    }

    protected setInteractionOnActivate() {
        this.btnActivate.on(PointerEvents.DOWN, (e) => {
            e.stopPropagation();
            BuyFeatureModel.isActivated = true;
            const betBarButtons = ViewManager.getLayer(DefaultLayers.BetBar).getCurrentScene().buttons;
            (betBarButtons.get(UIButtons.Spin) as SwitchButton).switch(true);
            (betBarButtons.get(UIButtons.Stop) as SwitchButton).switch(true);
            (betBarButtons.get(UIButtons.StopAutoplay) as SwitchButton).switch(true);
            (betBarButtons.get(UIButtons.Bet) as SwitchButton).switch(true);
            this.betBarBetField.visible = true;

            BuyFeatureModel.mode = 2;
            // mode is zero based
            // Feature Spin = "betMode": 3
            // that's why is +1
            BuyFeatureModel.extraParams = [
                { "betMode": BuyFeatureModel.mode +1 }
            ]

            BuyFeatureModel.hasBuyFeatureIsTriggered = true;
            const bfBet = BuyFeatureModel.getBet();

            CommandManager.execute(Commands.SET_BET, {
                coinIndex: BetModel.creditValues.indexOf(bfBet),
                multiplier: undefined,
                value: bfBet
            });

            const featSpinButton = betBarButtons.get("buyfeatureSpin") as SwitchButton;
            featSpinButton.switch(!featSpinButton.isSelected());

            this.btnActivate.off(PointerEvents.DOWN);
            KeyboardManager.enable();
            ViewManager.getLayer(DefaultLayers.SplashOverlay).completeClear();
            this.hide();
        });
    }
}
